import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
export interface AlertParams {
  message: string;
  type: AlertTypeEnum;
}

export enum AlertTypeEnum {
  Warning,
  Error,
  Info,
}

@Component({
  selector: 'tcs-alert-inline',
  templateUrl: './alert-inline.component.html',
  styleUrls: ['./alert-inline.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AlertInlineComponent implements OnInit {
  @Input()
  public params: AlertParams;

  constructor() {}

  public ngOnInit() {}

  get isError() {
    return this.params.type === AlertTypeEnum.Error;
  }
}
